import meta from './meta'

var wincount = 0 // for ep windows

var closest = function closest (el, fn) {
    while (el) {
        if (fn(el)) {
            return el
        }
        el = el.parentNode
    }
}

var getClosestCPC = function getClosestCPC (elm) {
    return closest(elm, function (el) {
        return el && el.getAttribute && el.getAttribute('data-cpc') ? true : false
    })
}

var processRevenue = function processRevenue (event) {
    if (getClosestCPC(event.target)) {
        event.stopPropagation()
        generateCCR(event.target)
        findSurvingInstitution(event.target)
        setClickType(event.target)
        setEventType(event.target)
        setClickedRowPosition(event.target)
        sendEP(event.target)

    }
}

var setClickType = function setClickType (elm) {
    var clicktype = null

    if (elm && elm.dataset && elm.dataset.clicktype) {
        clicktype = elm.dataset.clicktype
        meta.setMetaData('ClickType', clicktype)
    }

    return clicktype
}

var setEventType = function setEventType (elm) {
    var eventtype = null

    if (elm && elm.dataset && elm.dataset.eventtype) {
        eventtype = elm.dataset.eventtype
        meta.setMetaData('EventType', eventtype)
    }

    return eventtype
}

var extractRateTableValues = function extractRateTableValues (elm) {
    if (!elm) {
        elm = document.querySelector('body')
    }
    if (elm && elm.dataset) {
        // get the first UL element from the table, in case you need it.
        var nodes = document.querySelectorAll('ul.br-rate-table-row')
        var first = nodes[0]

        var products
        products = elm.dataset.products ? elm.dataset.products : false
        products = !products && (elm.dataset.riProductid ? elm.dataset.riProductid : false)
        products = !products && (first && first.dataset.productid ? first.dataset.productid : false)
        products = !products && (first && first.dataset.riProductid ? first.dataset.riProductid : false)

        // Get parameters
        var perdownElm = document.querySelector('#percentdown option:checked')
        var percdown
        percdown = elm.dataset.percdown ? elm.dataset.percdown : false
        percdown = !percdown && (first && first.dataset.percdown ? first.dataset.percdown : false)
        percdown = !percdown && (perdownElm ? perdownElm.value : false)

        var ficoElm = document.querySelector('#fico option:checked')
        var fico
        fico = elm.dataset.fico ? elm.dataset.fico : false
        fico = !fico && (ficoElm ? ficoElm.value : false)

        if (products) {
            meta.setMetaData('Product', products)
        }

        if (percdown) {
            meta.setMetaData('PercentDown', percdown)
        }

        if (fico) {
            meta.setMetaData('FicoScore', fico)
        }
    }
}

var generateCCR = function generateCCR (elm) {
    var CCRString = ''

    var cpcData = extractCPCData(elm)

    if (cpcData) {
        CCRString = 'CCR;p_' + cpcData.product + ';1;' + cpcData.unitPrice

        meta.setCCR(CCRString)
    }

    return CCRString
}

var extractCPCData = function extractCPCData (elm) {
    var cpcData = null
    var cpcString
    var cpcAfterPipe
    var cpcDataArray
    var elmdataset
    var override = false

    if (elm && elm.dataset && elm.dataset.cpc) {
        cpcString = elm.dataset.cpc
        elmdataset = elm.dataset
        if (elm && elm.dataset) {
            extractRateTableValues(elm)
        }
    } else {
        var cpcElm = getClosestCPC(elm)

        if (cpcElm && cpcElm.dataset && cpcElm.dataset.cpc) {
            cpcString = cpcElm.dataset.cpc
            elmdataset = cpcElm.dataset
        }
        if (cpcElm && cpcElm.dataset) {
            extractRateTableValues(cpcElm)
        }
    }

    if (elm && elm.dataset && elm.dataset.choverride) {
        override = elm.dataset.choverride === '1'
    }

    if (cpcString) {
        // check for ep.bankrate in cpc
        if (cpcString.indexOf('http://ep.') > -1) {
            cpcAfterPipe = cpcString.split('||')
            cpcData = {}
            if (cpcAfterPipe.length > 0) {
                cpcDataArray = []
                if (cpcAfterPipe[1]) {
                    cpcDataArray = cpcAfterPipe[1].split(',')
                }

                if (cpcDataArray.length > 0) {
                    cpcData = {}
                    cpcData.servingInstitution = cpcDataArray[0]
                    cpcData.market = cpcDataArray[1]
                    cpcData.product = cpcDataArray[2]
                    cpcData.unitPrice = override ? '0' : cpcDataArray[3]
                }
            }
        } else { // not ep calls, linksynergy
            cpcData = {}
            cpcData.product = document.querySelector('body[data-productid]').dataset.productid
            cpcData.unitPrice = 0
        }
    }

    if (cpcData && elmdataset) {
        cpcData.dataset = elmdataset
        return cpcData
    } else {
        return false
    }

}

var setClickedRowPosition = function setClickedRowPosition (elm) {
    var position = 0
    var cpcElm = getClosestCPC(elm)

    if (cpcElm) {
        var siblings = [].slice.call(cpcElm.parentNode.children).filter(function (e) {
            return (
                e.getAttribute &&
                e.getAttribute('data-paid') === 'true' ||
                e.getAttribute('data-paid') === 'false'
            ) && !(/omitcount/).test(e.className)
        })

        position = siblings.indexOf(cpcElm) + 1
    }

    meta.setClickedRow(position)

    return position
}

var sendEP = function sendEP (elm) {
    // TODO: move redirect ep into this file form old tracking

    var cpcData = extractCPCData(elm)
    var purID = meta.generatePurchaseID()

    // adding impression id and purchase id
    var impID = '0:0'

    if (cpcData) {
        // Overide click position
        if (elm.dataset && elm.dataset.position) {
            meta.setClickedRow = elm.dataset.position
        } else {
            setClickedRowPosition(elm)
        }

        // Get redirect link
        var cobrand = cpcData.dataset.cobrand
        var links = []
        var coreRedirect = ''
        var extraParametersIdx = -1

        if (cpcData.dataset && cpcData.dataset.cpc) {
            links = cpcData.dataset.cpc.split('||')
            coreRedirect = links[0]
            extraParametersIdx = links[1].indexOf('&')
        }

        // Build c param overrides
        var redirectTo
        redirectTo = coreRedirect

        // Add lead & other parameters if available
        if (extraParametersIdx !== -1) {
            redirectTo += links[1].substr(extraParametersIdx)
        }

        // If has a full EP link already, then ignore
        if (redirectTo.indexOf('ref_url=') === -1 && redirectTo.indexOf('c=') === -1) {

            if (coreRedirect.indexOf('http://oc.linkoffers.com') !== 0) {
                redirectTo += '&c='
                redirectTo += meta.getClickedRow()
                redirectTo += ','
                redirectTo += elm.dataset && elm.dataset.clicktype || ''
                redirectTo += ','
                redirectTo += elm.dataset && elm.dataset.choverride || ''
                redirectTo += ','
                redirectTo += elm.dataset.rediroverride && elm.dataset.rediroverride === '1' || elm.dataset && elm.dataset.eventtype === 'open' ? '1' : ''
                redirectTo += ','
                redirectTo += elm.dataset.profilelink ? encodeURIComponent(elm.dataset.profilelink) : ''
                redirectTo += ','
                redirectTo += cobrand ? cobrand : ''

                // Adds bidsort position to the URL
                if (cpcData && cpcData.dataset && cpcData.dataset.riBidactive && '1' === cpcData.dataset.riBidactive) {
                    redirectTo += '&bs=' + cpcData.dataset.riBidsort
                }

                // adding in date
                var today = new Date()
                var year = today.getFullYear()
                var month = today.getMonth() + 1
                var date = today.getDate()
                var hour = today.getHours()
                var minute = today.getMinutes()
                var second = today.getSeconds()
                var millisecond = today.getMilliseconds()
                var currentDT = month + '/' + date + '/' + year + ' ' + hour + ':' + minute + ':' + second + '.' + millisecond
                redirectTo += '&click_date=' + currentDT

                // adding in href
                var currenthref = window.top.location.href
                // remove epUrl if in currenthref
                currenthref = currenthref.replace(new RegExp('[?&]epUrl=[^&#]*(#.*)?$'), '$1')

                // Do not add referrer for CPL pages.
                if (currenthref.indexOf('bankrate.com/securecontact') === -1) {
                    redirectTo += '&ref_url=' + escape(currenthref)
                }

                redirectTo += purID ? '&pur_id=' + purID : ''
                redirectTo += impID ? '&imp_id=' + impID : ''
                redirectTo = redirectTo.replace(/&amp;/gi, '&')

            } else {
                redirectTo += '&oid=' + meta.getPurchaseID()
            }
        }

        var customeventbeforesend = new CustomEvent('bankrate:track:beforeEpSend', {
            detail: redirectTo
        })

        document.dispatchEvent(customeventbeforesend)

        // opens win for ep or redirects builds
        if (
            elm.dataset && elm.dataset.eventtype === 'open' ||
            elm.dataset.rediroverride && elm.dataset.rediroverride === '1' ||
            elm.dataset.name && elm.dataset.name === 'editorial' ||
            elm.dataset.paid && elm.dataset.paid === 'false'
        ) {
            var eppixel = document.createElement('img')
            eppixel.src = redirectTo

            document.body.appendChild(eppixel)

            if (typeof elm.dataset.phonenumber !== 'undefined') {
                setTimeout(function allowtrackingsignals () {
                    window.location = elm.dataset.phonenumber
                }, 300)

            }

        } else {

            var win = window.open(redirectTo, 'epwindow' + wincount)

            try {
                win.focus()
            } catch (e) {
                var wait4me = setTimeout(function () {
                    window.location = redirectTo
                }, 1000)
            }

            wincount++
        }

        var customeventsent = new CustomEvent('bankrate:track:epSent', {
            detail: {
                'redirectTo': redirectTo,
                'unitPrice': cpcData.unitPrice || '',
                'ccr': meta.getCCR() || '',
                'purchaseid': purID,
                'market': cpcData.market || '',
                'product': cpcData.product || '',
                'servingInstitution': cpcData.servingInstitution || '',
                'position': setClickedRowPosition(elm)
            }
        })

        document.dispatchEvent(customeventsent)
    }
}

var closeModal = function closeModal (event) {
    meta.generatePurchaseID()
}

var findSurvingInstitution = function findSurvingInstitution (elm) {
    var svyInst = ''
    var cpcElm = getClosestCPC(elm)

    if (typeof cpcElm !== 'undefined') {
        svyInst = cpcElm.dataset.riSvyinstitutionid
        meta.setServingInstitution(svyInst)
    }
}

var openModal = function openModal (event) {
    var modal = document.querySelector('.modal.in')

    var cpcElm = getClosestCPC(event.delegateTarget)

    if (typeof cpcElm === 'undefined') {
        cpcElm = getClosestCPC(event.relatedTarget)
    }

    if (typeof cpcElm !== 'undefined') {
        var svyInst = cpcElm.dataset.riSvyinstitutionid
        meta.setServingInstitution(svyInst)
    }

}

var sendRateTableWidgetTracking = function sendRateTableWidgetTracking (selector) {
    var PVstate = meta.getPageView()  // Store the current state of the Page View and restore it at the end.
    meta.setPageView(false)
    extractRateTableValues()
    meta.generatePurchaseID()

    if (selector && typeof selector === 'string') {
        var paids = meta.countPaidListings(selector) // eVar84
        var editorials = meta.countEditorialListings(selector) // eVar85
    }

    meta.setEvents('event28')
    meta.setPageView(true)
    meta.cleanHouse()
    meta.setPageView(PVstate)  // restore the state
}

var sendRateTableEPInterstital = function sendRateTableEPInterstital (selector, state, elm) {
    /** Selector can be null to check the whole page for the values, or a specific wrapper to count only items within it
     state : open / close
     elm : CPC element
     **/
    var PVstate = meta.getPageView()  // Store the current state of the Page View and restore it at the end.
    meta.setPageView(false)
    extractRateTableValues()
    meta.generatePurchaseID()
    if (elm) {
        setClickedRowPosition(elm)
        findSurvingInstitution(elm)
    }

    meta.buildRateImpression()

    if (selector && typeof selector === 'string') {
        var paids = meta.countPaidListings(selector) // eVar84
        var editorials = meta.countEditorialListings(selector) // eVar85
    }
    var customevent = new CustomEvent('bankrate:track:epinterstitial', {
        detail: {
            'action': state,
            'svyinstitutionid': elm && elm.dataset && elm.dataset.riSvyinstitutionid || ''
        }
    })

    document.dispatchEvent(customevent)

    meta.setPageView(true)
    meta.cleanHouse()
    meta.setPageView(PVstate)  // restore the state
}

var addSearchMarket = function addSearchMarket () {
    var marketElm = document.querySelector('[data-marketid]')
    meta.setMarketID(marketElm && marketElm.dataset && marketElm.dataset.marketid || '')
}

var isMobile = function isMobile () {
    var screenWith = window.screen.width

    return screenWith <= 640
}

var applyMobileTracking = function applyMobileTracking () {
    if (isMobile()) {
        // Add class "track" to cpc elm
        var paid = [].slice.call(document.querySelectorAll('.br-rate-table-row.paid'))
        var paidLightboxes = [].slice.call(document.querySelectorAll('.br-lender-info-modal .modal-content'))
        var trackElms = paid.concat(paidLightboxes)

        // check for class "norowtrack" - if exists, remove them from the list
        var norowtrack = [].slice.call(document.querySelectorAll('.br-rate-table-row.paid.br-no-row-click'))
        var newTrackElms = trackElms.filter(function (el) {
            return norowtrack.indexOf(el) < 0
        })
        if (newTrackElms.length > 0) {
            newTrackElms.forEach(function (e) {
                e.className += ' track'
            })
            clearTimeout(mobileTimer)
        } else {
            mobileTimer = setTimeout(applyMobileTracking, 500)
        }
    }
}

var sortChange = function sortChange (event) {
    var closestTable = closest(event.toElement, function (el) {
        return el && el.className && el.className.indexOf('br-rate-table-container') > -1 ? true : false
    })

    if (closestTable) {
        var rateTable = closestTable.querySelector('[data-ri-table-sort]')
        var sortMethod = rateTable && rateTable.getAttribute && rateTable.getAttribute('data-ri-table-sort')
        var sortDir = rateTable && rateTable.getAttribute && rateTable.getAttribute('data-ri-table-sortdir')
    }

}

// if mobile
var mobileTimer
mobileTimer = setTimeout(applyMobileTracking, 500)
extractRateTableValues()

document.addEventListener('bankrate.ratetable.filteredtable', addSearchMarket, true, true)
document.addEventListener('bankrate.ratetable.filteredtable', sortChange, true, true)
document.addEventListener('bankrate.ratetable.revenueclick', processRevenue, true, true)
document.addEventListener('bankrate.ratetable.closelightbox', closeModal)
document.addEventListener('bankrate.ratetable.openlightbox', openModal)

export default {
    processRevenue: processRevenue,
    extractCPCData: extractCPCData,
    generateCCR: generateCCR,
    sendEP: sendEP,
    sendRateTableWidgetTracking: sendRateTableWidgetTracking,
    sendRateTableEPInterstital: sendRateTableEPInterstital,
    extractRateTableValues: extractRateTableValues
}
